import type { CountryParamsType } from '~/app/types/countryParamsType';

export function useCountryParams() {
  const config = useRuntimeConfig();
  const unitCountryCode = config.public.unitCountryCode;

  return countryParams[unitCountryCode.toLowerCase() as keyof typeof countryParams] as CountryParamsType;
}
